import { CacheProvider } from '@emotion/react';
import '@fontsource/poppins';
import ReactDOM from 'react-dom/client';
import 'react-image-crop/dist/ReactCrop.css';
import AppContainer from './AppContainer';
import './index.css';
import { createEmotionCache } from './utils/emotionCache';

// Create Emotion cache with static key
const emotionCache = createEmotionCache();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <CacheProvider value={emotionCache}>
        <AppContainer />
    </CacheProvider>,
);
